var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.fixedTop ?'fixedTop':''},[(_vm.$route.name!='questionnaire')?_c('pageHeader'):_vm._e(),_c('router-view',{key:_vm.routerViewKey}),(_vm.$route.name!='questionnaire')?_c('pageFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }